module.exports = __webpack_public_path__ + "static/MensHealth-617e354d973cf560afd466772a08d3df.png";